import mixpanelPlugin from "@analytics/mixpanel";
import Analytics from "analytics";
import { isStagingEnv } from "./constants/config";

const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;

const analytics = Analytics({
    app: "ILLA-Admin",
    plugins: [
        mixpanelPlugin({
            token: mixpanelToken,
            options: { debug: isStagingEnv },
        }),
    ],
});

export default analytics;
